module.exports = __webpack_public_path__ + "img/google-play-fr-black.b8c6f92f.png";